import React, { useState } from 'react';
import Input from '../ui/Input';
import Space from '../ui/Space';
import Label from '../ui/Label';

const NoteTagEditor = (props) => {

    const { notesArr = [], note = "", editProps = () => {} } = props;

    // Parse initial string
    const [bracketedText, setBracketedText] = useState(notesArr);
    const [updatedString, setUpdatedString] = useState(note);

    // Handle input change for each bracketed text
    const handleChange = (index, value) => {
        const newText = [...bracketedText];
        newText[index] = value;
        setBracketedText(newText);
    };

    // Save the string based on the modified array
    const saveString = () => {
        let parts = note.split(/\[([^\]]+)\]/); // Split the string by the brackets
        let newString = parts.map((part, index) => {
            // Replace bracketed parts with corresponding array values
            return index % 2 === 1 ? `[${bracketedText[Math.floor(index / 2)]}]` : part;
        }).join('');

        setUpdatedString(newString);
    };

    return (
        <div>
            {/* Render existing bracketed text inputs */}
            <Space>
                <Label width={55}>Existing</Label>
                {bracketedText.map((text, index) => (
                    <div key={index}>
                        <Input {...editProps("note" + index)} maxLength={7} width={80} edit onChange={(e) => handleChange(index, e)} value={text} />
                    </div>
                ))}
            </Space>
        </div>
    );
};

export default NoteTagEditor;

